export default "__VITE_ASSET__BfsNkYHt__"